var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTelevisionIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 17.05L14.48 14.77C15.15 14.39 15.15 13.42 14.48 13.03L10.5 10.75C9.83 10.37 9 10.86 9 11.62V16.17C9 16.94 9.83 17.43 10.5 17.05ZM21 5.90001H13.41L16.35 2.96001C16.55 2.76001 16.55 2.45001 16.35 2.25001C16.15 2.05001 15.84 2.05001 15.64 2.25001L12 5.89001L8.36 2.25001C8.16 2.05001 7.85 2.05001 7.65 2.25001C7.45 2.45001 7.45 2.76001 7.65 2.96001L10.59 5.90001H3C1.9 5.90001 1 6.79001 1 7.90001V19.9C1 21 1.9 21.9 3 21.9H21C22.1 21.9 23 21 23 19.9V7.90001C23 6.79001 22.1 5.90001 21 5.90001ZM20 19.9H4C3.45 19.9 3 19.45 3 18.9V8.90001C3 8.35001 3.45 7.90001 4 7.90001H20C20.55 7.90001 21 8.35001 21 8.90001V18.9C21 19.45 20.55 19.9 20 19.9Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelevisionIcon);
export default __webpack_public_path__ + "static/media/TelevisionIcon.d6233a9a6c7c6090388869a9484c25e5.svg";
export { ForwardRef as ReactComponent };